export const SITE_SWITCHING_ACTIVE = 'SITE_SWITCHING_ACTIVE';

export function siteSwitchingActive(isSiteSwitchingActive) {
    return {
        type: SITE_SWITCHING_ACTIVE,
        payload: {
            siteSwitchingActive: isSiteSwitchingActive
        }
    };
}
